import * as React from "react";
import { SVGProps } from "react";
const BriefcaseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
    <circle cx={16} cy={16} r={16} fill="#F1F3F4" />
    <path
      fill="#6EACE5"
      d="M16 17.738c-5.24 0-8.05-4.417-9-6.27V23.77a.449.449 0 0 0 .449.449H24.55a.45.45 0 0 0 .449-.449v-12.3c-.95 1.85-3.76 6.269-9 6.269Z"
    />
    <path
      fill="#A6CBED"
      d="M24.551 11.003H7.45a.449.449 0 0 0-.449.449v.014c.95 1.853 3.76 6.272 9 6.272s8.05-4.417 9-6.27v-.014a.447.447 0 0 0-.449-.451Z"
    />
    <path
      fill="#228BE6"
      d="M17.216 16.784h-2.432a.374.374 0 0 0-.374.374v.904c0 .206.168.374.374.374h2.432a.374.374 0 0 0 .374-.374v-.904a.374.374 0 0 0-.374-.374Z"
    />
    <path
      fill="#A6CBED"
      d="M18.956 10.511a2.996 2.996 0 0 0-5.912 0A3.029 3.029 0 0 0 13 11a3 3 0 0 0 5.998 0 3.04 3.04 0 0 0-.043-.489ZM17.735 11a1.735 1.735 0 1 1-3.47 0 1.735 1.735 0 0 1 3.47 0Z"
    />
    <path
      fill="#6EACE5"
      d="M18.956 10.511h-1.292c.047.159.071.323.071.489H19a3.039 3.039 0 0 0-.044-.489ZM13.044 10.511A3.039 3.039 0 0 0 13 11h1.264c0-.166.024-.33.071-.489h-1.292Z"
    />
  </svg>
);
export default BriefcaseIcon;
